import { CoreSpace } from '@densityco/lib-api-types';

// These helpers abstract the calculations needed to project a scalar "count" value
// into a different analytics metric, based on a space's capacity fields and cost-per-seat info
// "count" can be a peak, an average-of-peaks, a time-weighted average, or an instantaneous count

export type CapacityField = 'capacity' | 'target_capacity' | 'safe_capacity';

export function ratioToPercent(ratio: number, decimalPlaces = 0): string | null {
  return ratio ? `${(100 * ratio).toFixed(decimalPlaces)}%` : null;
}

export function getUtilizationRatio(space: CoreSpace, count: number, capacityField: CapacityField): number | null {
  const capacityValue = space[capacityField];
  return capacityValue ? count / capacityValue : null;
}

export function getUtilizationPercent(
  space: CoreSpace,
  count: number,
  capacityField: CapacityField,
  decimalPlaces = 0
): string | null {
  const utilizationRatio = getUtilizationRatio(space, count, capacityField);
  return utilizationRatio !== null ? ratioToPercent(utilizationRatio, decimalPlaces) : null;
}

export function getOpportunitySeats(space: CoreSpace, count: number, capacityField: CapacityField): number | null {
  const capacityValue = space[capacityField];
  return capacityValue ? capacityValue - count : null;
}

export function getOpportunityCost(
  space: CoreSpace,
  count: number,
  capacityField: CapacityField,
  costPerSeat: number
): number | null {
  const capacityValue = space[capacityField];
  return capacityValue ? (capacityValue - count) * costPerSeat : null;
}
